import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useLogout } from '../model/auth.hooks';

export function Logout() {
	const navigate = useNavigate();
	const isLoading = useLogout();
	useEffect(() => {
		if (!isLoading) {
			navigate({
				to: '/',
				replace: true,
			});
		}
	}, [isLoading, navigate]);
	return <div />;
}

export default Logout;
